import React from 'react';
import useCreateDashboard from '../../utils/useCreateDashboard';
import { DashboardNavItem } from '../components';

const NewDashboardLink = () => {
  const { createDashboard, loading } = useCreateDashboard(false);

  return (
    <DashboardNavItem
      onClick={createDashboard}
      disabled={loading}
      iconName="plus"
      title={'New Dashboard'}
    />
  );
};

export default NewDashboardLink;
